import { Modal } from "@circle-react-uikit/ModalV2";
import { useEffect } from "react";
import type { ReactNode } from "react";

import type {
  UpgradePlanFooterConfig,
  UpgradePlanModalPrimaryAction,
  UpgradePlanModalSecondaryAction,
} from "./UpgradePlanModalConfigContext";
import { useSetUpgradePlanModalFooter } from "./UpgradePlanModalConfigContext";

interface UpgradePlanModalFooterProps {
  children?: ReactNode;
  className?: string;
  layout?: UpgradePlanFooterConfig["layout"];
  primaryAction?: UpgradePlanModalPrimaryAction;
  secondaryAction?: UpgradePlanModalSecondaryAction;
  startContent?: ReactNode;
}

export const UpgradePlanModalFooter = ({
  children,
  className,
  startContent,
  layout,
  secondaryAction,
  primaryAction,
}: UpgradePlanModalFooterProps) => {
  const setFooterConfig = useSetUpgradePlanModalFooter();
  const footerChildren = primaryAction ? undefined : children;

  useEffect(() => {
    if (setFooterConfig) {
      setFooterConfig({
        children: footerChildren,
        className,
        startContent,
        layout,
        secondaryAction,
        primaryAction,
      });
    }
    return () => {
      setFooterConfig?.(null);
    };
  }, [
    setFooterConfig,
    footerChildren,
    className,
    startContent,
    layout,
    secondaryAction,
    primaryAction,
  ]);

  if (setFooterConfig) {
    return null;
  }

  return <Modal.Footer className={className}>{children}</Modal.Footer>;
};
